/**
 * Created by Julio Perez on 5/24/2016.
 */

routing.$inject = ['$urlRouterProvider', '$locationProvider', '$compileProvider'];

    export default function routing($urlRouterProvider, $locationProvider, $compileProvider){
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
    $compileProvider.debugInfoEnabled(false);

}


// WEBPACK FOOTER //
// ./src/app/app.routes.js